import React from 'react';
import PropTypes from 'prop-types';

import FreemiumEventCreateReviewStepUpdate from './FreemiumEventCreateReviewStepUpdate';
import withModal from '../../../../../../../../../components/global/modal/withModal';

export const FREEMIUM_EVENT_CREATE_REVIEW_STEP_UPDATE_MODAL =
  'modal/FREEMIUM_EVENT_CREATE_REVIEW_STEP_UPDATE';

const propTypes = {
  actionProps: PropTypes.shape({
    step: PropTypes.shape({
      validate: PropTypes.func,
      component: PropTypes.node,
    }),
  }),
  onRequestClose: PropTypes.func,
};

const FreemiumEventCreateReviewStepUpdateModal = ({
  actionProps: { step } = {},
  onRequestClose,
  ...props
}) => {
  if (!step?.component) {
    return null;
  }

  return (
    <FreemiumEventCreateReviewStepUpdate
      step={step}
      onComplete={onRequestClose}
      {...props}
    />
  );
};

FreemiumEventCreateReviewStepUpdateModal.propTypes = propTypes;

export default withModal(FreemiumEventCreateReviewStepUpdateModal, {
  name: FREEMIUM_EVENT_CREATE_REVIEW_STEP_UPDATE_MODAL,
  size: 'md',
  type: 'full',
});
